import styled from 'styled-components'
import { Button } from '@quotatisgroup/uikit-public.ui.button'

export const Form = styled.form`
  * > div {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  svg {
    filter: grayscale(100%);
  }

  input {
    width: 100%;
    height: 40px;
    padding: 0 10px;
    background-color: #f7f9fc;
    border: 1px solid #e6ebf3;
    border-radius: 4px;
    color: #212b44;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    box-sizing: border-box;
    font-size: 13px;
  }
`

export const StyledButton = styled(Button)`
  width: 100%;
`
